module.exports = __webpack_public_path__ + "static/media/flag-icon-24px.29e19134.svg";